import { CustomerServiceOutlined, HomeOutlined, GatewayOutlined } from '@ant-design/icons'
import { Outlet, useLocation } from 'react-router'
import MenuItem from '../../Components/Menu/MenuItem'
import SubMenu from '../../Components/Menu/SubMenu'
import AuthBaseLayout from '../AuthBaseLayout'
import { LayoutProps } from './types'
import { useState } from 'react'
import { checkAuthorizationV2 } from 'Models/AuthorizeV2/checkAuthorizationV2'

// @ts-expect-error : Will update later
export const HomeLayout = ({ header, children, ...props }: LayoutProps) => {
  const location = useLocation()
  const [activeSubMenu, setactiveSubMenu] = useState<string | undefined>(undefined)

  const apiGatewayAdminPageVisible = checkAuthorizationV2(
    {
      requiredPolicies: [],
      locationReference: { organisationUUID: '' },
    },
    ['$api_gateway_admin']
  )

  return (
    <AuthBaseLayout
      menu={[
        <MenuItem
          key="home"
          to={`/`}
          icon={<HomeOutlined />}
          onOpen={() => setactiveSubMenu(undefined)}
        >
          Clients
        </MenuItem>,
        <SubMenu
          activeKey={activeSubMenu}
          submenuKey={'engage'}
          key="engage"
          title={'Engage'}
          icon={<CustomerServiceOutlined />}
          defaultOpen={location.pathname.includes('engage')}
          selected={location.pathname.includes('engage')}
          onOpen={() => setactiveSubMenu('engage')}
        >
          <MenuItem key="engage" subMenuItem to={`/engage/demos`}>
            Demo Gallery
          </MenuItem>
          <MenuItem key="engage" subMenuItem to={`/engage/interactive`}>
            Interactive
          </MenuItem>
          <MenuItem key="engage" subMenuItem to={`/engage/tts`}>
            TTS
          </MenuItem>
          <MenuItem
            key="engage"
            subMenuItem
            to={`/engage/settings/tags`}
            selected={location.pathname.includes('engage/settings')}
          >
            Settings
          </MenuItem>
        </SubMenu>,
        // <LinkItem key="teams" to={`/teams`} icon={<TeamOutlined />} onClick={() => {}} disabled>
        //   <ComingSoonMenu title="Teams"></ComingSoonMenu>
        // </LinkItem>,
        // <LinkItem key="learn" to={`/learn`} icon={<BookOutlined />} disabled>
        //   <ComingSoonMenu title="Learn"></ComingSoonMenu>
        // </LinkItem>,
        <SubMenu
          activeKey={activeSubMenu}
          submenuKey={'telephony'}
          key="telephony"
          title={'Telephony'}
          icon={<CustomerServiceOutlined />}
          defaultOpen={location.pathname.includes('telephony')}
          selected={location.pathname.includes('telephony')}
          onOpen={() => setactiveSubMenu('telephony')}
        >
          <MenuItem key="clients" subMenuItem to={`/telephony/clients`}>
            Clients
          </MenuItem>
          <MenuItem key="providers" subMenuItem to={`/telephony/providers`}>
            Providers
          </MenuItem>
          <MenuItem key="virtual_numbers" subMenuItem to={`/telephony/virtual-numbers`}>
            Virtual Numbers
          </MenuItem>
          {(window as any)?.appConfig?.REGION !== 'US' && (
            <MenuItem key="blacklist_numbers" subMenuItem to={`/telephony/blacklist-numbers`}>
              Do Not Call List
            </MenuItem>
          )}
          <MenuItem key="workers" subMenuItem to={`/telephony/workers`}>
            Workers
          </MenuItem>
          <MenuItem key="concurrency" subMenuItem to={`/telephony/concurrency`}>
            Concurrency
          </MenuItem>
        </SubMenu>,
        apiGatewayAdminPageVisible && (
          <MenuItem
            key="home"
            to={`/apigateway-admin`}
            icon={<GatewayOutlined />}
            onOpen={() => setactiveSubMenu(undefined)}
          >
            Apigateway
          </MenuItem>
        ),
      ]}
      header={header}
    >
      <Outlet />
      {children}
    </AuthBaseLayout>
  )
}
